// Chain configurations for the confidential tokens application
export const CHAINS = {
    arbitrum: {
        id: 'arbitrum',
        network: 'testnet',
        name: 'Arbitrum Sepolia',
        symbol: 'ARB',
        chainId: '0x66eee', // 421614 in hex (Arbitrum Sepolia)
        chainIdDecimal: 421614,
        rpcUrl: process.env.REACT_APP_ARBITRUM_RPC_URL || 'https://sepolia-rollup.arbitrum.io/rpc',
        blockExplorerUrl: process.env.REACT_APP_ARBITRUM_BLOCK_EXPLORER || 'https://sepolia.arbiscan.io',
        nativeCurrency: {
            name: 'Ethereum',
            symbol: 'ETH',
            decimals: 18
        },
        icon: '/arbitrum.png', // Arbitrum icon
        color: '#28A0F0',
        active: true, // Enabled on testnet (see TESTNET_ENABLED_CHAIN_IDS)
        contractAddress: process.env.REACT_APP_ARBITRUM_CONTRACT_ADDRESS || '0x147C6D8cA1a4784Ed76d98b0E3CcA41C38a49A5f',
        tokens: {
            usdc: {
                address: process.env.REACT_APP_ARBITRUM_USDC_ADDRESS || '0x75faf114eafb1BDbe2F0316DF893fd58CE46AA4d',
                decimals: 6,
                symbol: 'USDC',
                name: 'USD Coin',
                icon: '/usdc.png',
                color: '#2775CA'
            },
            usdt: {
                address: process.env.REACT_APP_ARBITRUM_USDT_ADDRESS || '0x2367dDf156601b411479A3745B20f0618055270E',
                decimals: 6,
                symbol: 'USDT',
                name: 'Tether USD',
                icon: '/usdt.png',
                color: '#26A17B'
            },
            cusd: {
                address: process.env.REACT_APP_ARBITRUM_CUSD_ADDRESS || '0x0000000000000000000000000000000000000000',
                decimals: 6,
                symbol: 'CUSD',
                name: 'Confidential USD',
                icon: '/cusd.svg',
                color: '#000000',
                active: false, // Coming soon
            }
        }
    },
    arbitrum_mainnet: {
        id: 'arbitrum_mainnet',
        network: 'mainnet',
        name: 'Arbitrum',
        symbol: 'ARB',
        chainId: '0xa4b1', // 42161 in decimal (Arbitrum One)
        chainIdDecimal: 42161,
        rpcUrl: process.env.REACT_APP_ARBITRUM_MAINNET_RPC_URL || 'https://arb1.arbitrum.io/rpc',
        blockExplorerUrl: process.env.REACT_APP_ARBITRUM_MAINNET_BLOCK_EXPLORER || 'https://arbiscan.io',
        nativeCurrency: {
            name: 'Ethereum',
            symbol: 'ETH',
            decimals: 18
        },
        icon: '/arbitrum.png',
        color: '#28A0F0',
        // Matches @fairblock/stabletrust 2.0.16+ STABLETRUST_CONTRACTS_BY_CHAIN_ID[42161].
        active: true,
        contractAddress: process.env.REACT_APP_ARBITRUM_MAINNET_CONTRACT_ADDRESS || '0xCAA6384D5Ac8b9111D482dd676BB890f2b6e9513',
        tokens: {
            usdc: {
                address: process.env.REACT_APP_ARBITRUM_MAINNET_USDC_ADDRESS || '0xaf88d065e77c8cC2239327C5EDb3A432268e5831',
                decimals: 6,
                symbol: 'USDC',
                name: 'USD Coin',
                icon: '/usdc.png',
                color: '#2775CA'
            },
            usdt: {
                address: process.env.REACT_APP_ARBITRUM_MAINNET_USDT_ADDRESS || '0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9',
                decimals: 6,
                symbol: 'USDT',
                name: 'Tether USD',
                icon: '/usdt.png',
                color: '#26A17B'
            },
            cusd: {
                address: process.env.REACT_APP_ARBITRUM_MAINNET_CUSD_ADDRESS || '0xE327833c6D4C35A50F47be9474D995d7CD2F6Cd7',
                decimals: 6,
                symbol: 'CUSD',
                name: 'Confidential USD',
                icon: '/cusd.svg',
                color: '#000000',
                active: true,
            },
            usdg: {
                // Paxos USDG on Arbitrum One: https://docs.paxos.com/guides/stablecoin/usdg/mainnet
                address: process.env.REACT_APP_ARBITRUM_MAINNET_USDG_ADDRESS || '0x004B506865409877C9fA29bfb1ebA929984B9bbC',
                decimals: 6,
                symbol: 'USDG',
                name: 'Global Dollar',
                icon: '/usdg.png',
                color: '#26A17B'
            }
        }
    },
    // Distinct from `ethereum` (Sepolia) — never interchange the two config keys.
    ethereum_mainnet: {
        id: 'ethereum_mainnet',
        network: 'mainnet',
        name: 'Ethereum',
        symbol: 'ETH',
        chainId: '0x1', // 1 in decimal (Ethereum Mainnet)
        chainIdDecimal: 1,
        rpcUrl: process.env.REACT_APP_ETHEREUM_MAINNET_RPC_URL || 'https://ethereum-rpc.publicnode.com',
        blockExplorerUrl: process.env.REACT_APP_ETHEREUM_MAINNET_BLOCK_EXPLORER || 'https://etherscan.io',
        nativeCurrency: {
            name: 'Ethereum',
            symbol: 'ETH',
            decimals: 18
        },
        icon: '/ethereum.png',
        color: '#627EEA',
        // Matches @fairblock/stabletrust 2.0.16+ STABLETRUST_CONTRACTS_BY_CHAIN_ID[1].
        active: true,
        contractAddress: process.env.REACT_APP_ETHEREUM_MAINNET_CONTRACT_ADDRESS || '0xa9661635cc97756190973Ef281d4529693EcAcD0',
        tokens: {
            usdc: {
                address: process.env.REACT_APP_ETHEREUM_MAINNET_USDC_ADDRESS || '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
                decimals: 6,
                symbol: 'USDC',
                name: 'USD Coin',
                icon: '/usdc.png',
                color: '#2775CA'
            },
            usdt: {
                address: process.env.REACT_APP_ETHEREUM_MAINNET_USDT_ADDRESS || '0xdAC17F958D2ee523a2206206994597C13D831ec7',
                decimals: 6,
                symbol: 'USDT',
                name: 'Tether USD',
                icon: '/usdt.png',
                color: '#26A17B'
            },
            cusd: {
                address: process.env.REACT_APP_ETHEREUM_MAINNET_CUSD_ADDRESS || '0xE327833c6D4C35A50F47be9474D995d7CD2F6Cd7',
                decimals: 6,
                symbol: 'CUSD',
                name: 'Confidential USD',
                icon: '/cusd.svg',
                color: '#000000',
                active: true,
            }
        }
    },
    ethereum: {
        id: 'ethereum',
        network: 'testnet',
        name: 'Ethereum',
        symbol: 'ETH',
        chainId: '0xaa36a7', // 11155111 in hex (Ethereum Sepolia)
        chainIdDecimal: 11155111,
        rpcUrl: process.env.REACT_APP_ETHEREUM_RPC_URL || 'https://ethereum-sepolia-rpc.publicnode.com',
        blockExplorerUrl: process.env.REACT_APP_ETHEREUM_BLOCK_EXPLORER || 'https://sepolia.etherscan.io',
        nativeCurrency: {
            name: 'Ethereum',
            symbol: 'ETH',
            decimals: 18
        },
        icon: '/ethereum.png',
        color: '#627EEA',
        active: true, // Enabled on testnet (see TESTNET_ENABLED_CHAIN_IDS)
        contractAddress: process.env.REACT_APP_ETHEREUM_CONTRACT_ADDRESS || '0x7507a13352AFAa79D33E994f86f2f62463ba8DE4', // Gateway contract address to be set
        tokens: {
            usdc: {
                address: process.env.REACT_APP_ETHEREUM_USDC_ADDRESS || '0x1c7D4B196Cb0C7B01d743Fbc6116a902379C7238',
                faucetAddress: process.env.REACT_APP_ETHEREUM_USDC_FAUCET_ADDRESS || '0x81D0B89Fbf8f8593C41dfec17516BB583e8D47b8',
                decimals: 6,
                symbol: 'USDC',
                name: 'USD Coin',
                icon: '/usdc.png',
                color: '#2775CA'
            },
            usdt: {
                address: process.env.REACT_APP_ETHEREUM_USDT_ADDRESS || '0x7a7B410fc367B1Da3d9a50EC7BD6B0778a6B34f5',
                faucetAddress: process.env.REACT_APP_ETHEREUM_USDT_FAUCET_ADDRESS || '0xF4871c6eF4b78Fe98c3c9658C7F3BB8Fc4c301f2',
                decimals: 6,
                symbol: 'USDT',
                name: 'Tether USD',
                icon: '/usdt.png',
                color: '#26A17B'
            },
            usdg: {
                address: process.env.REACT_APP_ETHEREUM_USDG_ADDRESS || '0xfBb2A78CceEb415b00300925e464C3E44E6e06b0',
                faucetAddress: process.env.REACT_APP_ETHEREUM_USDG_FAUCET_ADDRESS || '0x0000000000000000000000000000000000000000',
                decimals: 6,
                symbol: 'USDG',
                name: 'Global Dollar',
                icon: '/usdg.png',
                color: '#26A17B'
            }
        }
    },
    hyperevm: {
        id: 'hyperevm',
        network: 'testnet',
        name: 'HyperEVM',
        symbol: 'HYPE',
        chainId: '0x9a9', // Placeholder chainId
        chainIdDecimal: 2473,
        rpcUrl: process.env.REACT_APP_HYPEREVM_RPC_URL || 'https://rpc.hyperevm.com',
        blockExplorerUrl: process.env.REACT_APP_HYPEREVM_BLOCK_EXPLORER || 'https://explorer.hyperevm.com',
        nativeCurrency: {
            name: 'HyperEVM',
            symbol: 'HYPE',
            decimals: 18
        },
        icon: '/hyperevm.png',
        color: '#FF6B35',
        active: false, // Coming soon
        contractAddress: process.env.REACT_APP_HYPEREVM_CONTRACT_ADDRESS || '', // To be deployed
        tokens: {
            usdc: {
                address: '0x0000000000000000000000000000000000000000',
                decimals: 6,
                symbol: 'USDC',
                name: 'USD Coin',
                icon: '/usdc.png',
                color: '#2775CA'
            },
            usdt: {
                address: '0x0000000000000000000000000000000000000000',
                decimals: 6,
                symbol: 'USDT',
                name: 'Tether USD',
                icon: '/usdt.png',
                color: '#26A17B'
            }
        }
    },
    monad: {
        id: 'monad',
        network: 'testnet',
        name: 'Monad',
        symbol: 'MON',
        chainId: '0x9b1', // Placeholder chainId
        chainIdDecimal: 2481,
        rpcUrl: process.env.REACT_APP_MONAD_RPC_URL || 'https://rpc.monad.xyz',
        blockExplorerUrl: process.env.REACT_APP_MONAD_BLOCK_EXPLORER || 'https://explorer.monad.xyz',
        nativeCurrency: {
            name: 'Monad',
            symbol: 'MON',
            decimals: 18
        },
        icon: '/monad.png',
        color: '#9333EA',
        active: false, // Coming soon
        contractAddress: process.env.REACT_APP_MONAD_CONTRACT_ADDRESS || '', // To be deployed
        tokens: {
            usdc: {
                address: '0x0000000000000000000000000000000000000000',
                decimals: 6,
                symbol: 'USDC',
                name: 'USD Coin',
                icon: '/usdc.png',
                color: '#2775CA'
            },
            usdt: {
                address: '0x0000000000000000000000000000000000000000',
                decimals: 6,
                symbol: 'USDT',
                name: 'Tether USD',
                icon: '/usdt.png',
                color: '#26A17B'
            }
        }
    },
    plasma: {
        id: 'plasma',
        network: 'testnet',
        name: 'Plasma',
        symbol: 'PLASMA',
        chainId: '0x9c4', // Placeholder chainId
        chainIdDecimal: 2500,
        rpcUrl: process.env.REACT_APP_PLASMA_RPC_URL || 'https://rpc.plasma.network',
        blockExplorerUrl: process.env.REACT_APP_PLASMA_BLOCK_EXPLORER || 'https://explorer.plasma.network',
        nativeCurrency: {
            name: 'Plasma',
            symbol: 'PLASMA',
            decimals: 18
        },
        icon: '/plasma.png',
        color: '#14B8A6',
        active: false, // Coming soon
        contractAddress: process.env.REACT_APP_PLASMA_CONTRACT_ADDRESS || '', // To be deployed
        tokens: {
            usdc: {
                address: '0x0000000000000000000000000000000000000000',
                decimals: 6,
                symbol: 'USDC',
                name: 'USD Coin',
                icon: '/usdc.png',
                color: '#2775CA'
            },
            usdt: {
                address: '0x0000000000000000000000000000000000000000',
                decimals: 6,
                symbol: 'USDT',
                name: 'Tether USD',
                icon: '/usdt.png',
                color: '#26A17B'
            }
        }
    },
    base: {
        id: 'base',
        network: 'testnet',
        name: 'Base',
        symbol: 'ETH',
        chainId: '0x14a34', // 84532 in decimal (Base Sepolia)
        chainIdDecimal: 84532,
        rpcUrl: process.env.REACT_APP_BASE_RPC_URL || 'https://sepolia.base.org',
        blockExplorerUrl: process.env.REACT_APP_BASE_BLOCK_EXPLORER || 'https://sepolia-explorer.base.org',
        nativeCurrency: {
            name: 'Ethereum',
            symbol: 'ETH',
            decimals: 18
        },
        icon: '/base.png',
        color: '#0052FF',
        active: true, // Enabled on testnet (see TESTNET_ENABLED_CHAIN_IDS)
        contractAddress: process.env.REACT_APP_BASE_CONTRACT_ADDRESS || '0x73D2bc5B5c7aF5C3726E7bEf0BD8b4931923fdA9',
        tokens: {
            usdc: {
                address: process.env.REACT_APP_BASE_USDC_ADDRESS || '0x036CbD53842c5426634e7929541eC2318f3dCF7e',
                faucetAddress: process.env.REACT_APP_BASE_USDC_FAUCET_ADDRESS || '0xf559D0d5c6d36193345ffB5a164885BCA2C1d4f0',
                decimals: 6,
                symbol: 'USDC',
                name: 'USD Coin',
                icon: '/usdc.png',
                color: '#2775CA'
            },
            usdt: {
                address: process.env.REACT_APP_BASE_USDT_ADDRESS || '0x8d9cb8f3191Fd685e2C14D2AC3Fb2b16D44EAfc3',
                faucetAddress: process.env.REACT_APP_BASE_USDT_FAUCET_ADDRESS || '0x801050790018234895D167619B8a2C7af6EBc4de',
                decimals: 6,
                symbol: 'USDT',
                name: 'Tether USD',
                icon: '/usdt.png',
                color: '#26A17B'
            }
        }
    },
    // Distinct from `base` (Base Sepolia) — never interchange the two config keys.
    base_mainnet: {
        id: 'base_mainnet',
        network: 'mainnet',
        name: 'Base',
        symbol: 'ETH',
        chainId: '0x2105', // 8453 in decimal (Base Mainnet)
        chainIdDecimal: 8453,
        // Prefer PublicNode over mainnet.base.org — the official public RPC
        // rate-limits aggressively (HTTP 429), which aborts account-creation
        // pre-checks before the wallet popup can appear.
        rpcUrl: process.env.REACT_APP_BASE_MAINNET_RPC_URL || 'https://base-rpc.publicnode.com',
        blockExplorerUrl: process.env.REACT_APP_BASE_MAINNET_BLOCK_EXPLORER || 'https://basescan.org',
        nativeCurrency: {
            name: 'Ethereum',
            symbol: 'ETH',
            decimals: 18
        },
        icon: '/base.png',
        color: '#0052FF',
        // Matches @fairblock/stabletrust 2.0.16+ STABLETRUST_CONTRACTS_BY_CHAIN_ID[8453].
        active: true,
        contractAddress: process.env.REACT_APP_BASE_MAINNET_CONTRACT_ADDRESS || '0xF90a80eef61e934CF20E5B4fa48FBe9F5fB58aED',
        tokens: {
            usdc: {
                address: process.env.REACT_APP_BASE_MAINNET_USDC_ADDRESS || '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913',
                decimals: 6,
                symbol: 'USDC',
                name: 'USD Coin',
                icon: '/usdc.png',
                color: '#2775CA'
            },
            usdt: {
                address: process.env.REACT_APP_BASE_MAINNET_USDT_ADDRESS || '0xfde4C96c8593536E31F229EA8f37b2ADa2699bb2',
                decimals: 6,
                symbol: 'USDT',
                name: 'Tether USD',
                icon: '/usdt.png',
                color: '#26A17B'
            },
            cusd: {
                address: process.env.REACT_APP_BASE_MAINNET_CUSD_ADDRESS || '0x0000000000000000000000000000000000000000',
                decimals: 6,
                symbol: 'CUSD',
                name: 'Confidential USD',
                icon: '/cusd.svg',
                color: '#000000',
                active: false, // Coming soon
            }
        }
    },
    noble: {
        id: 'noble',
        network: 'testnet',
        name: 'Noble',
        symbol: 'NOBL',
        chainId: '0x0', // Cosmos-based chain (no EVM chainId)
        chainIdDecimal: 0,
        rpcUrl: process.env.REACT_APP_NOBLE_RPC_URL || 'https://rpc.noblechain.io',
        blockExplorerUrl: process.env.REACT_APP_NOBLE_BLOCK_EXPLORER || 'https://mintscan.io/noble',
        nativeCurrency: {
            name: 'Noble',
            symbol: 'NOBL',
            decimals: 6
        },
        icon: '/noble.png',
        color: '#4C7DD1',
        active: false, // Coming soon
        contractAddress: process.env.REACT_APP_NOBLE_CONTRACT_ADDRESS || '', // To be deployed
        tokens: {
            usdc: {
                address: '0x0000000000000000000000000000000000000000',
                decimals: 6,
                symbol: 'USDC',
                name: 'USD Coin',
                icon: '/usdc.png',
                color: '#2775CA'
            },
            usdt: {
                address: '0x0000000000000000000000000000000000000000',
                decimals: 6,
                symbol: 'USDT',
                name: 'Tether USD',
                icon: '/usdt.png',
                color: '#26A17B'
            }
        }
    },
    arc: {
        id: 'arc',
        network: 'testnet',
        name: 'Arc',
        symbol: 'ARC',
        chainId: process.env.REACT_APP_ARC_CHAIN_ID || '0x4CEF52', 
        chainIdDecimal: Number(process.env.REACT_APP_ARC_CHAIN_ID_DECIMAL) || 5042002,
        rpcUrl: process.env.REACT_APP_ARC_RPC_URL || 'https://rpc.testnet.arc.network',
        blockExplorerUrl: process.env.REACT_APP_ARC_BLOCK_EXPLORER || 'https://testnet.arcscan.app',
        nativeCurrency: {
            name: 'USDC',
            symbol: 'USDC',
            decimals: 6
        },
        // RPC fee data (gasPrice / maxFeePerGas) is wei-style; use 18-decimal units for gas-cost math/formatting.
        gasFeeUnitDecimals: 18,
        // Arc wallet fee UI tracks closer to priority-fee pricing for "Network fee".
        estimateNetworkFeeFromPriorityFee: true,
        icon: '/arc.png',
        color: '#6C5CE7',
        active: true, // Enabled on testnet (see TESTNET_ENABLED_CHAIN_IDS)
        contractAddress: process.env.REACT_APP_ARC_CONTRACT_ADDRESS || '0x1Bf79BF5A32D6f3cdce3fe1A93c3fB222Bc93bb3', // To be updated when deployed
        tokens: {
            usdc: {
                address: process.env.REACT_APP_ARC_USDC_ADDRESS || '0x3600000000000000000000000000000000000000',
                faucetAddress: process.env.REACT_APP_ARC_USDC_FAUCET_ADDRESS || 'https://faucet.circle.com/?_gl=1*h6h29y*_gcl_au*MTAxMTkyOTU0Ny4xNzYyODA2NjQ5',
                decimals: 6,
                symbol: 'USDC',
                name: 'USD Coin',
                icon: '/usdc.png',
                color: '#2775CA'
            },
            usdt: {
                address: process.env.REACT_APP_ARC_USDT_ADDRESS || '0xb9f5A4f5e0af148A9D2e751De2754Ff7950F34d4',
                faucetAddress: process.env.REACT_APP_ARC_USDT_FAUCET_ADDRESS || '0x78e913645e90844F7fCe185cDabb89CA0A158a71',
                decimals: 6,
                symbol: 'USDT',
                name: 'Tether USD',
                icon: '/usdt.png',
                color: '#26A17B'
            }
        }
    },
    stable: {
        id: 'stable',
        network: 'testnet',
        name: 'Stable',
        symbol: 'STABLE',
        chainId: process.env.REACT_APP_STABLE_CHAIN_ID || '0x899', // 2201 in hex
        chainIdDecimal: Number(process.env.REACT_APP_STABLE_CHAIN_ID_DECIMAL) || 2201,
        rpcUrl: process.env.REACT_APP_STABLE_RPC_URL || 'https://rpc.testnet.stable.xyz',
        blockExplorerUrl: process.env.REACT_APP_STABLE_BLOCK_EXPLORER || 'https://stablescan.xyz/',
        nativeCurrency: {
            name: 'gUSDT',
            symbol: 'gUSDT',
            decimals: 6
        },
        // RPC fee data (gasPrice / maxFeePerGas) is wei-style; use 18-decimal units for gas-cost math/formatting.
        gasFeeUnitDecimals: 18,
        // Stable wallet fee UI tracks closer to priority-fee pricing for "Network fee".
        estimateNetworkFeeFromPriorityFee: true,
        icon: '/stable.png',
        color: '#6366F1',
        active: true, // Enabled on testnet (see TESTNET_ENABLED_CHAIN_IDS)
        contractAddress: process.env.REACT_APP_STABLE_CONTRACT_ADDRESS || '0xb0b461aFA69b715d842c7fAb602f50D4cef83fe5',
        tokens: {
            usdc: {
                address: process.env.REACT_APP_STABLE_USDC_ADDRESS || '0x0000000000000000000000000000000000000000',
                decimals: 6,
                symbol: 'USDC',
                name: 'USD Coin',
                icon: '/usdc.png',
                color: '#2775CA'
            },
            usdt: {
                address: process.env.REACT_APP_STABLE_USDT_ADDRESS || '0x78Cf24370174180738C5B8E352B6D14c83a6c9A9',
                decimals: 6,
                symbol: 'USDT',
                name: 'Tether USD',
                icon: '/usdt.png',
                color: '#26A17B'
            }
        }
    },
    // Distinct from `bnb_mainnet` (BSC) — never interchange the two config keys.
    bnb: {
        id: 'bnb',
        network: 'testnet',
        name: 'BNB',
        symbol: 'BNB',
        chainId: '0x61', // 97 in decimal (BNB Smart Chain Testnet)
        chainIdDecimal: 97,
        rpcUrl: process.env.REACT_APP_BNB_RPC_URL || 'https://data-seed-prebsc-1-s1.binance.org:8545',
        blockExplorerUrl: process.env.REACT_APP_BNB_BLOCK_EXPLORER || 'https://testnet.bscscan.com',
        nativeCurrency: {
            name: 'BNB',
            symbol: 'tBNB',
            decimals: 18
        },
        icon: '/bnb.png',
        color: '#F0B90B',
        active: true, // Enabled on testnet (see TESTNET_ENABLED_CHAIN_IDS)
        contractAddress: process.env.REACT_APP_BNB_CONTRACT_ADDRESS || '0xDF64401cb981823012369d5fB4adCe93050bCD99',
        tokens: {
            usdc: {
                address: process.env.REACT_APP_BNB_USDC_ADDRESS || '0x64544969ed7EBf5f083679233325356EbE738930',
                decimals: 18,
                symbol: 'USDC',
                name: 'USD Coin',
                icon: '/usdc.png',
                color: '#2775CA'
            },
            usdt: {
                address: process.env.REACT_APP_BNB_USDT_ADDRESS || '',
                decimals: 6,
                symbol: 'USDT',
                name: 'Tether USD',
                icon: '/usdt.png',
                color: '#26A17B'
            }
        }
    },
    // Distinct from `bnb` (BSC Testnet) — never interchange the two config keys.
    bnb_mainnet: {
        id: 'bnb_mainnet',
        network: 'mainnet',
        name: 'BNB',
        symbol: 'BNB',
        chainId: '0x38', // 56 in decimal (BNB Smart Chain Mainnet)
        chainIdDecimal: 56,
        rpcUrl: process.env.REACT_APP_BNB_MAINNET_RPC_URL || 'https://bsc-rpc.publicnode.com',
        blockExplorerUrl: process.env.REACT_APP_BNB_MAINNET_BLOCK_EXPLORER || 'https://bscscan.com',
        nativeCurrency: {
            name: 'BNB',
            symbol: 'BNB',
            decimals: 18
        },
        icon: '/bnb.png',
        color: '#F0B90B',
        active: true,
        contractAddress: process.env.REACT_APP_BNB_MAINNET_CONTRACT_ADDRESS || '0x6148515C41180c2E5d8E4557C3e01c7F22087288',
        tokens: {
            usdc: {
                // Binance-Peg USDC on BSC (18 decimals)
                address: process.env.REACT_APP_BNB_MAINNET_USDC_ADDRESS || '0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d',
                decimals: 18,
                symbol: 'USDC',
                name: 'USD Coin',
                icon: '/usdc.png',
                color: '#2775CA'
            },
            usdt: {
                // Binance-Peg USDT on BSC (18 decimals)
                address: process.env.REACT_APP_BNB_MAINNET_USDT_ADDRESS || '0x55d398326f99059fF775485246999027B3197955',
                decimals: 18,
                symbol: 'USDT',
                name: 'Tether USD',
                icon: '/usdt.png',
                color: '#26A17B'
            },
            cusd: {
                address: process.env.REACT_APP_BNB_MAINNET_CUSD_ADDRESS || '0x0000000000000000000000000000000000000000',
                decimals: 6,
                symbol: 'CUSD',
                name: 'Confidential USD',
                icon: '/cusd.svg',
                color: '#000000',
                active: false, // Coming soon
            }
        }
    },
    solana: {
        id: 'solana',
        network: 'testnet',
        name: 'Solana',
        symbol: 'SOL',
        chainId: '0x0', // Solana doesn't use EVM chainId
        chainIdDecimal: 0,
        rpcUrl: process.env.REACT_APP_SOLANA_RPC_URL || 'https://api.mainnet-beta.solana.com',
        blockExplorerUrl: process.env.REACT_APP_SOLANA_BLOCK_EXPLORER || 'https://explorer.solana.com',
        nativeCurrency: {
            name: 'Solana',
            symbol: 'SOL',
            decimals: 9
        },
        icon: '/solana.png',
        color: '#14F195',
        active: false, // Coming soon
        contractAddress: process.env.REACT_APP_SOLANA_CONTRACT_ADDRESS || '', // To be deployed
        tokens: {
            usdc: {
                address: '0x0000000000000000000000000000000000000000',
                decimals: 6,
                symbol: 'USDC',
                name: 'USD Coin',
                icon: '/usdc.png',
                color: '#2775CA'
            },
            usdt: {
                address: '0x0000000000000000000000000000000000000000',
                decimals: 6,
                symbol: 'USDT',
                name: 'Tether USD',
                icon: '/usdt.png',
                color: '#26A17B'
            }
        }
    },
    tempo: {
        id: 'tempo',
        network: 'testnet',
        name: 'Tempo',
        symbol: 'TEMPO',
        chainId: process.env.REACT_APP_TEMPO_CHAIN_ID || '0xa5bf', // 42431 in hex
        chainIdDecimal: Number(process.env.REACT_APP_TEMPO_CHAIN_ID_DECIMAL) || 42431,
        rpcUrl: process.env.REACT_APP_TEMPO_RPC_URL || 'https://rpc.moderato.tempo.xyz',
        blockExplorerUrl: process.env.REACT_APP_TEMPO_BLOCK_EXPLORER || 'https://explore.testnet.tempo.xyz/',
        nativeCurrency: {
            name: 'USDC',
            symbol: 'USDC',
            decimals: 6
        },
        // RPC fee data is wei-style even though fees are paid in stable tokens.
        gasFeeUnitDecimals: 18,
        // Tempo wallet fee UI tracks closer to priority-fee pricing for "Network fee".
        estimateNetworkFeeFromPriorityFee: true,
        icon: '/tempo.png',
        color: '#6366F1',
        active: false, // Temporarily disabled
        contractAddress: process.env.REACT_APP_TEMPO_CONTRACT_ADDRESS || '0xE559fB936C69c46E216bf61B07C16bF1a6d444aa',
        // Per-tx limit: 17M+ rejected; 16.8M gives "gas limit too high"; use 16.5M (withdraw may OOG - needs contract-side optimization)
        maxGasLimit: 16500000,
        // Fee tokens that can be used to pay transaction fees on Tempo
        feeTokens: [
            {
                address: '0x20c0000000000000000000000000000000000000',
                symbol: 'PathUSD',
                name: 'Path USD',
                decimals: 6
            },
            {
                address: '0x20c0000000000000000000000000000000000001',
                symbol: 'AlphaUSD',
                name: 'Alpha USD',
                decimals: 6
            },
            {
                address: '0x20c0000000000000000000000000000000000002',
                symbol: 'BetaUSD',
                name: 'Beta USD',
                decimals: 6
            },
            {
                address: '0x20c0000000000000000000000000000000000003',
                symbol: 'ThetaUSD',
                name: 'Theta USD',
                decimals: 6
            }
        ],
        tokens: {
            pathusd: {
                address: '0x20c0000000000000000000000000000000000000',
                decimals: 6,
                symbol: 'PathUSD',
                name: 'Path USD',
                icon: '/usdc.png',
                color: '#2775CA'
            },
            alphausd: {
                address: '0x20c0000000000000000000000000000000000001',
                decimals: 6,
                symbol: 'AlphaUSD',
                name: 'Alpha USD',
                icon: '/usdc.png',
                color: '#2775CA'
            },
            betausd: {
                address: '0x20c0000000000000000000000000000000000002',
                decimals: 6,
                symbol: 'BetaUSD',
                name: 'Beta USD',
                icon: '/usdc.png',
                color: '#2775CA'
            },
            thetausd: {
                address: '0x20c0000000000000000000000000000000000003',
                decimals: 6,
                symbol: 'ThetaUSD',
                name: 'Theta USD',
                icon: '/usdc.png',
                color: '#2775CA'
            }
        }
    },
    // Robinhood Chain mainnet (Arbitrum Orbit L2). No testnet sibling in-app yet.
    robinhood_mainnet: {
        id: 'robinhood_mainnet',
        network: 'mainnet',
        name: 'Robinhood',
        symbol: 'ETH',
        chainId: '0x1237', // 4663 in decimal
        chainIdDecimal: 4663,
        rpcUrl: process.env.REACT_APP_ROBINHOOD_MAINNET_RPC_URL || 'https://rpc.mainnet.chain.robinhood.com',
        blockExplorerUrl: process.env.REACT_APP_ROBINHOOD_MAINNET_BLOCK_EXPLORER || 'https://robinhoodchain.blockscout.com',
        nativeCurrency: {
            name: 'Ethereum',
            symbol: 'ETH',
            decimals: 18
        },
        icon: '/robinhood.png',
        color: '#CCFF00',
        active: true,
        contractAddress: process.env.REACT_APP_ROBINHOOD_MAINNET_CONTRACT_ADDRESS || '0xe76F1D7501ee4617fa2Cdf166680810EDC7bF4E0',
        tokens: {
            usdg: {
                address: process.env.REACT_APP_ROBINHOOD_MAINNET_USDG_ADDRESS || '0x5fc5360D0400a0Fd4f2af552ADD042D716F1d168',
                decimals: 6,
                symbol: 'USDG',
                name: 'Global Dollar',
                icon: '/usdg.png',
                color: '#26A17B'
            },
            usde: {
                address: process.env.REACT_APP_ROBINHOOD_MAINNET_USDE_ADDRESS || '0x5d3a1Ff2b6BAb83b63cd9AD0787074081a52ef34',
                decimals: 18,
                symbol: 'USDe',
                name: 'Ethena USDe',
                icon: '/usde.png',
                color: '#1A5D3A'
            }
        }
    }
};

// Helper function to get active chains
export const getActiveChains = () => {
    return Object.values(CHAINS).filter(chain => chain.active);
};

/**
 * Resolve a CHAINS config key/entry from an EVM chain id.
 * Mainnet and testnet versions are separate configs (e.g. `arbitrum` vs
 * `arbitrum_mainnet`, `ethereum` vs `ethereum_mainnet`, `base` vs
 * `base_mainnet`, `bnb` vs `bnb_mainnet`) — never treat them as interchangeable.
 *
 * @param {string|number} evmChainId - decimal or hex chain id from the wallet
 * @param {{ preferredKey?: string, network?: 'mainnet'|'testnet' }} [opts]
 *   preferredKey: UI/session selection — wins when its EVM id matches
 *   network: when set, only return a chain from that universe
 * @returns {{ key: string, chain: object } | null}
 */
export const resolveChainEntry = (evmChainId, opts = {}) => {
    const { preferredKey = null, network = null } = opts;
    if (evmChainId == null || evmChainId === '') return null;

    const idNum =
        typeof evmChainId === 'string' && evmChainId.startsWith('0x')
            ? parseInt(evmChainId, 16)
            : Number(evmChainId);
    if (!Number.isFinite(idNum) || idNum === 0) return null;

    const matchesNetwork = (chain) =>
        !network || chain?.network === network;

    if (preferredKey && CHAINS[preferredKey]) {
        const preferred = CHAINS[preferredKey];
        if (
            preferred.chainIdDecimal === idNum &&
            matchesNetwork(preferred)
        ) {
            return { key: preferredKey, chain: preferred };
        }
    }

    const matches = Object.entries(CHAINS).filter(
        ([, chain]) =>
            chain.chainIdDecimal === idNum && matchesNetwork(chain),
    );
    if (matches.length === 0) return null;
    // Prefer an exact config-key match if preferredKey was given but EVM
    // ids differed (caller can still use wallet match); otherwise first hit.
    // With unique EVM ids per config this is unambiguous today.
    const [key, chain] = matches[0];
    return { key, chain };
};

/** @returns {object|null} chain config only */
export const resolveChainConfig = (evmChainId, opts = {}) =>
    resolveChainEntry(evmChainId, opts)?.chain || null;

/** @returns {string|null} CHAINS config key only */
export const resolveChainKey = (evmChainId, opts = {}) =>
    resolveChainEntry(evmChainId, opts)?.key || null;

/** Bare token key from a composite `${chainId}_${tokenId}` id.
 * Chain keys may themselves contain underscores (e.g. `arbitrum_mainnet`,
 * `ethereum_mainnet`, `base_mainnet`, `bnb_mainnet`), so never use `id.split('_')[1]`.
 */
export const tokenIdFromCompositeId = (compositeId, chainId) => {
    if (!compositeId) return null;
    if (typeof compositeId === 'object' && compositeId.tokenId) {
        return compositeId.tokenId;
    }
    const id = String(compositeId);
    if (chainId && id.startsWith(`${chainId}_`)) {
        return id.slice(String(chainId).length + 1);
    }
    const lastUnderscore = id.lastIndexOf('_');
    return lastUnderscore >= 0 ? id.slice(lastUnderscore + 1) : id;
};

/** Display name for pills/selectors — always the distinct config name. */
export const getChainDisplayName = (chainOrKey) => {
    const chain =
        typeof chainOrKey === 'string' ? CHAINS[chainOrKey] : chainOrKey;
    if (!chain) return 'Unknown Chain';
    return chain.name;
};

/** True when both refer to the same CHAINS config key (not just same brand). */
export const isSameChainConfig = (a, b) => {
    const keyA = typeof a === 'string' ? a : a?.id;
    const keyB = typeof b === 'string' ? b : b?.id;
    return !!keyA && keyA === keyB;
};

// Helper function to get chain by EVM ID (decimal or hex).
// Prefer resolveChainEntry when you also have a UI selection / network mode.
export const getChainById = (chainId, opts = {}) => {
    if (typeof chainId === 'string' && CHAINS[chainId]) {
        return CHAINS[chainId];
    }
    return resolveChainConfig(chainId, opts);
};

// Helper function to get popular chains. network selects which universe of
// chains this returns — 'testnet' (default, matches every existing caller)
// or 'mainnet'. Mainnet uses dedicated sibling configs (arbitrum_mainnet,
// ethereum_mainnet, base_mainnet, bnb_mainnet) rather than the testnet entries,
// so the list reads as "here's the roadmap" instead of "here's the only chain"
// — which ones are actually selectable in each list is a separate question,
// answered by isChainEnabledForNetwork below, not by this ordering.
// IMPORTANT: each entry's `id` is the config key to select — mainnet
// siblings (`*_mainnet`) and testnet keys must never be swapped.
export const getPopularChains = (network = 'testnet') => {
    const chainOrder = network === 'mainnet'
        ? ['arbitrum_mainnet', 'ethereum_mainnet', 'base_mainnet', 'bnb_mainnet', 'robinhood_mainnet', 'stable', 'arc', 'hyperevm', 'monad', 'plasma', 'noble', 'solana', 'tempo']
        : ['arbitrum', 'ethereum', 'base', 'stable', 'arc', 'bnb', 'hyperevm', 'monad', 'plasma', 'noble', 'solana', 'tempo'];
    return chainOrder.map(id => CHAINS[id]).filter(Boolean);
};

// Which chains are actually selectable, split by network mode — every
// chain above still appears in getPopularChains (so it reads as "coming
// soon", not "doesn't exist"), just disabled outside its enabled set here.
// Kept separate from each chain's own `active` field further up: that
// field predates the mainnet/testnet toggle and doesn't vary by network,
// so enabled-ness comes from the current toggle position, not from a
// single flag baked into the object. Mainnet and testnet siblings always
// use distinct config keys (never reuse a Sepolia entry under Mainnet).
const TESTNET_ENABLED_CHAIN_IDS = ['arbitrum', 'ethereum', 'base', 'stable', 'arc', 'bnb'];
const MAINNET_ENABLED_CHAIN_IDS = ['arbitrum_mainnet', 'ethereum_mainnet', 'base_mainnet', 'bnb_mainnet', 'robinhood_mainnet'];

export const isChainEnabledForNetwork = (chainId, network = 'testnet') =>
    (network === 'mainnet' ? MAINNET_ENABLED_CHAIN_IDS : TESTNET_ENABLED_CHAIN_IDS).includes(chainId);

/** Symbols the token picker / history may treat as selectable when active. */
const ENABLED_TOKEN_SYMBOLS = ['USDC', 'USDT', 'CUSD', 'USDG', 'USDe'];

const isValidTokenAddress = (address) => {
    if (!address) return false;
    const addr = String(address).trim().toLowerCase();
    if (addr === '' || addr === '0x0000000000000000000000000000000000000000') return false;
    return /^0x[a-f0-9]{40}$/.test(addr);
};

/**
 * Whether a token is selectable for the given chain + network mode.
 * Requires a non-zero address and token.active !== false (USDC/USDT/USDG/USDe
 * omit active and default to enabled; CUSD is gated per-chain via active).
 */
export const isTokenEnabledForNetwork = (chainId, symbol, network = 'testnet') => {
    if (!isChainEnabledForNetwork(chainId, network)) return false;
    if (!ENABLED_TOKEN_SYMBOLS.includes(symbol)) return false;
    const token = Object.values(CHAINS[chainId]?.tokens || {}).find(
        (t) => t.symbol === symbol,
    );
    if (!token || token.active === false) return false;
    return isValidTokenAddress(token.address);
};

/**
 * Confidential-balance ticker shown in the UI.
 * USDC → CUSDC; CUSD → "Private CUSD" (never CCUSD).
 */
export const toConfidentialSymbol = (symbol, name = '') => {
    if (!symbol) return symbol;
    if (symbol === 'CUSD') return 'Private CUSD';
    if (String(name).toLowerCase().startsWith('confidential')) return symbol;
    return `C${symbol}`;
};

/**
 * Confidential-balance display name shown in the UI.
 * USDC → "Confidential USD Coin"; CUSD → "Private CUSD".
 */
export const toConfidentialName = (symbol, name = '') => {
    if (symbol === 'CUSD') return 'Private CUSD';
    if (String(name).toLowerCase().startsWith('confidential')) return name;
    return name ? `Confidential ${name}` : name;
};

/** Network mode ('mainnet'|'testnet') implied by a CHAINS config key. */
export const getNetworkModeForChain = (chainKey) =>
    CHAINS[chainKey]?.network === 'mainnet' ? 'mainnet' : 'testnet';

/** Default selectable chain for a network mode. */
export const getDefaultChainIdForNetwork = (network = 'testnet') =>
    network === 'mainnet' ? 'arbitrum_mainnet' : 'arbitrum';

// Helper function to get all tokens across all chains
export const getAllTokens = () => {
    const allTokens = {};
    Object.values(CHAINS).forEach(chain => {
        Object.entries(chain.tokens).forEach(([tokenId, token]) => {
            const key = `${chain.id}_${tokenId}`;
            allTokens[key] = {
                ...token,
                chainId: chain.id,
                chainName: chain.name,
                chainIcon: chain.icon,
                chainColor: chain.color
            };
        });
    });
    return allTokens;
};

// Helper function to get popular tokens (USDC, USDT, DAI across chains)
export const getPopularTokens = () => {
    const popularTokenSymbols = ['USDC', 'USDT', 'DAI', 'USDG', 'USDe'];
    const popularTokens = [];
    
    Object.values(CHAINS).forEach(chain => {
        Object.entries(chain.tokens).forEach(([tokenId, token]) => {
            if (popularTokenSymbols.includes(token.symbol)) {
                popularTokens.push({
                    ...token,
                    id: `${chain.id}_${tokenId}`,
                    chainId: chain.id,
                    chainName: chain.name,
                    chainIcon: chain.icon,
                    chainColor: chain.color,
                    chainActive: chain.active
                });
            }
        });
    });
    
    return popularTokens;
};
